import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import ServiceSection from '../../components/ServiceSection/ServiceSection'
import ServiceList from '../../components/ServiceList/ServiceList';
import About from '../../components/about/about';
import Testimonial from '../../components/Testimonial/Testimonial';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'

const HomePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero hclass={'hero-section'} />
            <ServiceSection hclass={"service-section section-padding"} SectionShowTopimg={true} />
            <ServiceList />
            <About hclass={'about-section section-padding'} />
            <Testimonial tClass={'testimonial-section section-padding'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;